import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, object_type, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../Utils';

import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    const fetch_id_info = () => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => { 
                //setData(res.data);
                //setLoading(false) 
                if(object_type === getTokenInfo().profile) {
                    res.data.forEach(v => {
                        //console.log('ID ', getTokenInfo().id)
                        //console.log('V ', v.id)
                        if((v.id) === getTokenInfo().id){
                            //console.log('AQUI', v)
                            //console.log('AQUI TODOS', res.data)
                            setData([v]); 
                        }
                    });
                }
                else {
                    setData(res.data); 
                } 
                setLoading(false) 
            })
            .catch(() => 404
            )
    }

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }


    useEffect(() => {
        fetch_id_info()

        set_lang(localStorage.getItem('lang'))

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            });
    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})

    }

    const columns = [
        {
            name: language[lang].name,
            selector: 'name',
            sortable: true,
            let: true,
        },
        {
            name: language[lang].username,
            selector: 'username',
            sortable: true,
            let: true,
        },
        {
            name: language[lang].profile,
            selector: 'profile',
            sortable: true,
            left: true,
        },
        {
            name: '',
            left: true,
            export: false,
            cell: row =>
                <span>
                    {
                    permissions.edit ?
                        <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                            <i className="bi bi-eye"></i>
                            <span className="tooltiptext">{language[lang].view}</span>
                        </Link>
                        :
                        null
                    }

                    {
                    permissions.edit ?
                        <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} replace>
                            <i className="bi bi-pencil"></i>
                            <span className="tooltiptext">{language[lang].edit}</span>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.remove ?
                        <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(row['id'])} >
                            <i className="bi bi-trash"></i>
                        </button>
                    :
                        null
                    }
                </span >
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?
    
        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].trainee}</h2>
                <p>{language[lang].trainee} / {language[lang].trainee_list}</p>
            </div>
        
            <div className={`dash-cards body`}>
                <div className="container">
                    
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                        
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-5">
                                        <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>

                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}